<template>
    <div id="config-business">
        <FilterView placeholder="Chercher un groupe métier..." v-model="searchTerm">
            <CustomButton
                v-if="selected.length"
                icon="trash-alt"
                class="default red-theme"
                @click="showConfirmMany = true"
            >
                Supprimer
            </CustomButton>
            <CustomButton icon="plus" class="default green-theme" @click="handleNew">
                Ajouter un groupe métier
            </CustomButton>
        </FilterView>
        <Modal
            v-if="showEdit"
            v-model="group"
            :users="users"
            @dismiss="showEdit = false"
            @close="handleClose"
        />
        <Confirm v-if="showConfirmOne" @dismiss="showConfirmOne = false" @close="handleDeleteOne">
            <span slot="header">Supprimer le groupe métier</span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer ce groupe métier ?<br />
                Les utilisateurs appartenant à ce groupe ne seront pas supprimés.
            </span>
        </Confirm>
        <Confirm
            v-if="showConfirmMany"
            @dismiss="showConfirmMany = false"
            @close="handleDeleteMany"
        >
            <span slot="header">
                Supprimer {{ selected.length }}
                {{ selected.length > 1 ? 'groupes' : 'groupe' }} métier
            </span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer les groupes métier sélectionnés ?<br />
                Les utilisateurs appartenant à ces groupes ne seront pas supprimés.
            </span>
        </Confirm>
        <h2 class="title">Groupes métier</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager>
            <BusinessCard
                v-for="item in filtered"
                :item="item"
                :key="item.id"
                :handleEdit="handleEdit"
                :handleConfirm="handleConfirm"
                :selected="selected"
                @selected="handleSelect"
            />
        </CardPager>
    </div>
</template>

<script>
import FilterView from '@/components/config/Filter';
import Modal from '@/components/config/ModalBusiness';
import Confirm from '@/components/config/DeleteConfirm';
import CustomButton from '@/components/Button';
import LoadingDots from '@/components/LoadingDots';
import BusinessCard from '@/components/config/BusinessCard';
import CardPager from '@/components/CardPager';

export default {
    data() {
        return {
            showEdit: false,
            showConfirmOne: false,
            showConfirmMany: false,
            groups: [],
            users: [],
            group: null,
            selected: [],
            searchTerm: null,
            isLoading: true,
        };
    },
    watch: {
        searchTerm() {
            this.selected.splice(0);
        },
    },
    computed: {
        filtered() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.groups.filter((t) => re.test(t.name));
            }
            return this.groups;
        },
    },
    mounted() {
        Promise.all([this.$http.get('/api/business-group'), this.$http.get('/api/user')]).then(
            (responses) => {
                // success callback
                this.groups = responses[0].body;
                this.users = responses[1].body.map((u) => ({
                    id: u.id,
                    text: `${u.first_name} ${u.last_name}`,
                }));
                this.isLoading = false;
            },
            (responses) => {
                // error callback
                console.log(JSON.stringify(responses));
                this.isLoading = false;
            },
        );
    },
    methods: {
        _getGroup(id) {
            const group = this.groups.find((g) => g.id === id);
            return {
                ...group,
                users: group.users.map((u) => ({
                    id: u.id,
                    text: `${u.first_name} ${u.last_name}`,
                })),
            };
        },
        handleSelect(event) {
            const { id, checked } = event;
            const index = this.selected.findIndex((s) => s === id);
            if (checked) {
                if (index === -1) {
                    this.selected.push(id);
                }
            } else {
                if (index > -1) {
                    this.selected.splice(index, 1);
                }
            }
        },
        handleConfirm(item) {
            this.group = this._getGroup(item);
            this.showConfirmOne = true;
        },
        handleEdit(item) {
            this.group = this._getGroup(item);
            this.showEdit = true;
        },
        handleClose() {
            // Crée le nouveau groupe métier, si le nom du groupe métier est renseigné
            if (!this.group.id && this.group.name) {
                this.$http
                    .post('/api/business-group', this.group)
                    .then((response) => {
                        const group = response.body;
                        this.groups.push(group);
                        this.showEdit = false;
                        this.group = null;
                    })
                    .catch();
                // Met à jour le groupe métier, si le nom du groupe métier est renseigné
            } else if (this.group.id && this.group.name) {
                this.$http
                    .put(`/api/business-group/${this.group.id}`, this.group)
                    .then((response) => {
                        const group = response.body;
                        const index = this.groups.findIndex((g) => g.id === group.id);
                        this.groups.splice(index, 1, group);
                        this.showEdit = false;
                        this.group = null;
                    })
                    .catch();
            }
        },
        handleNew() {
            this.group = {
                id: null,
                name: '',
                users: [],
            };
            this.showEdit = true;
        },
        handleDeleteOne() {
            this.$http
                .delete(`/api/business-group/${this.group.id}`)
                .then(() => {
                    const index = this.groups.findIndex((g) => g.id === this.group.id);
                    this.groups.splice(index, 1);
                    this.showConfirmOne = false;
                })
                .catch();
        },
        handleDeleteMany() {
            const requests = this.selected.map((s) =>
                this.$http.delete(`/api/business-group/${s}`),
            );
            Promise.all(requests)
                .then(() => {
                    this.showConfirmMany = false;
                    this.selected.splice(0);
                    this.isLoading = true;
                    return this.$http.get('/api/business-group');
                })
                .then((response) => {
                    // success callback
                    this.groups = response.body;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
    },
    components: {
        Modal,
        Confirm,
        FilterView,
        CustomButton,
        LoadingDots,
        BusinessCard,
        CardPager,
    },
};
</script>

<style lang="scss"></style>
